import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Scale, Lock } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { apiErr } from "@/lib/api";
import { useSeo } from "@/lib/useSeo";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  useSeo({ title: "Admin Login | Adv. Guruvayoorappan K V", robots: "noindex, nofollow" });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim(), password);
      toast.success("Welcome back");
      nav("/admin/dashboard");
    } catch (err) {
      toast.error(apiErr(err.response?.data?.detail, "Invalid email or password"));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-navy flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="absolute inset-0 opacity-[0.05]" style={{ backgroundImage: "radial-gradient(circle at 1px 1px, #C5A059 1px, transparent 0)", backgroundSize: "28px 28px" }} />
      <div className="relative w-full max-w-md">
        <div className="text-center mb-8">
          <span className="w-14 h-14 mx-auto rounded-sm border border-brass/50 flex items-center justify-center text-brass mb-4"><Scale size={26} /></span>
          <h1 className="font-serif text-2xl text-ivory">Admin Dashboard</h1>
          <p className="text-ivory/50 text-sm mt-1">Adv. Guruvayoorappan K V</p>
        </div>
        <form onSubmit={submit} className="bg-navy-light border border-brass/20 rounded-lg p-8 space-y-5">
          <div>
            <label className="block text-xs font-semibold text-ivory/70 mb-1.5 uppercase tracking-wide">Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              className="w-full bg-navy border border-ivory/15 rounded-sm px-4 py-3 text-ivory text-sm focus:outline-none focus:border-brass"
              placeholder="admin email" data-testid="admin-login-email" />
          </div>
          <div>
            <label className="block text-xs font-semibold text-ivory/70 mb-1.5 uppercase tracking-wide">Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
              className="w-full bg-navy border border-ivory/15 rounded-sm px-4 py-3 text-ivory text-sm focus:outline-none focus:border-brass"
              placeholder="••••••••" data-testid="admin-login-password" />
          </div>
          <button type="submit" disabled={loading}
            className="w-full bg-brass hover:bg-brass-hover text-navy font-semibold py-3.5 rounded-sm flex items-center justify-center gap-2 transition-colors disabled:opacity-60" data-testid="admin-login-submit">
            {loading ? <Loader2 size={18} className="animate-spin" /> : <Lock size={16} />} Sign In
          </button>
        </form>
      </div>
    </div>
  );
}
